/**
 * Injects form.css into the Shopify Forms shadow DOM.
 *
 * Uses adoptedStyleSheets rather than a <link>: the app applies its own styles the
 * same way, and adopted sheets are evaluated after ShadowRoot.styleSheets, so an
 * appended <link> loses at equal specificity. Adopted sheets also survive the app
 * replacing the shadow root's innerHTML (e.g. the post-submit success state).
 *
 * Requires the asset URL to be passed in from Liquid — theme assets are served from
 * a versioned CDN path (/cdn/shop/t/N/assets/...), not /assets/. In theme.liquid:
 *
 *   <script>window.__formCssHref = {{ 'form.css' | asset_url | json }};</script>
 *   <script src="{{ 'form-css-inject.js' | asset_url }}" defer></script>
 */
(function () {
    var HREF = window.__formCssHref;
    var HOSTS = ['shopify-forms-embed', 'form-embed'];

    if (!HREF) {
        console.warn('[form-css] window.__formCssHref is not set — see header comment');
        return;
    }

    var sheetPromise = null;

    function getSheet() {
        if (sheetPromise) return sheetPromise;

        sheetPromise = fetch(HREF)
            .then(function (res) {
                if (!res.ok) throw new Error(res.status + ' fetching ' + HREF);
                return res.text();
            })
            .then(function (css) {
                var sheet = new CSSStyleSheet();
                sheet.replaceSync(css);
                if (!sheet.cssRules.length) {
                    console.warn('[form-css] stylesheet loaded but parsed to 0 rules');
                }
                return sheet;
            });

        return sheetPromise;
    }

    function inject(root) {
        if (!root || root.__formCssInjected) return;
        root.__formCssInjected = true; // set before await — the observer fires constantly

        getSheet()
            .then(function (sheet) {
                if (root.adoptedStyleSheets.indexOf(sheet) === -1) {
                    root.adoptedStyleSheets.push(sheet);
                }
            })
            .catch(function (err) {
                root.__formCssInjected = false; // allow a later pass to retry
                console.warn('[form-css]', err.message);
            });
    }

    var observed = new WeakSet();

    function observe(root) {
        if (!root || observed.has(root)) return;
        observed.add(root);
        new MutationObserver(function () {
            walk(document);
        }).observe(root, {childList: true, subtree: true});
    }

    // Light DOM + every open shadow root, depth-first.
    function walk(root) {
        root.querySelectorAll('*').forEach(function (el) {
            if (!el.shadowRoot) return;
            if (HOSTS.indexOf(el.tagName.toLowerCase()) !== -1) inject(el.shadowRoot);
            observe(el.shadowRoot);
            walk(el.shadowRoot);
        });
    }

    function init() {
        getSheet(); // warm the fetch immediately

        walk(document);
        observe(document.body);

        // Not a gate — just an extra trigger if the app script lands late.
        HOSTS.forEach(function (tag) {
            customElements.whenDefined(tag).then(function () {
                walk(document);
            });
        });

        if (window.Shopify && window.Shopify.designMode) {
            document.addEventListener('shopify:section:load', function () {
                walk(document);
            });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, {once: true});
    } else {
        init();
    }
})();